export const SEPA_COUNTRIES = [
  'IT', // Italy
  'ES', // Spain
  'FR', // France
  'PT', // Portugal
  'DK', // Denmark
  'LU', // Luxembourg
  'BE', // Belgium
  'DE', // Germany
  'NL', // Netherlands
  'IE', // Ireland
  'SI', // Slovenia
  'GR', // Greece
  'BG', // Bulgaria
  'MC', // Monaco
  'AT', // Austria
  'FI', // Finland
  'CY', // Cyprus
  'EE', // Estonia
  'LV', // Latvia
  'LT', // Lithuania
  'MT', // Malta
  'PL', // Poland
  'CZ', // Czech Republic
  'SK', // Slovakia
  'HU', // Hungary
  'SE', // Sweden
  'HR', // Croatia
  'RO', // Romania
  'CH', // Switzerland
  'AD', // Andorra
];
